import React from 'react';

import styles from './styles.module.css';
import type { ProgressLabelProps } from './types';

export const ProgressLabel: React.FC<ProgressLabelProps> = ({
  label,
  position,
  renderWidthPx,
  shouldTruncate,
  maxWidthPx,
  labelTextContentRef,
}) => {
  const truncatedTextStyle =
    shouldTruncate && typeof maxWidthPx === 'number'
      ? ({
          '--label-max-width': `${maxWidthPx}px`,
        } as React.CSSProperties)
      : undefined;

  return (
    <div
      className={`${styles.progressLabel} ${
        position === 'left' ? styles.labelLeft : styles.labelRight
      }`}
      style={{ width: `${renderWidthPx}px` }}
      aria-hidden="true"
      data-testid="progress-label"
    >
      <span className={styles.labelBubble} aria-hidden="true" />
      <span className={styles.labelText}>
        <span
          ref={labelTextContentRef}
          className={`${styles.labelTextContent} ${
            shouldTruncate ? styles.labelTextContentTruncated : ''
          }`}
          style={truncatedTextStyle}
        >
          {label}
        </span>
      </span>
    </div>
  );
};
